import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useCallback, useEffect } from 'react';

import type { TPassportFormFields } from 'entities/creditForm';
import { useGetLocationSettlement } from 'entities/creditForm';

export const useRegistrationLocationRouteLoader = () => {
  const { watch, setValue } = useFormContext<TPassportFormFields>();
  const [loadLocationSettlement, { data }] = useGetLocationSettlement();
  const registrationAddress = watch('registrationAddress');

  const getLocationSettlement = useCallback(
    async (address: string) => {
      loadLocationSettlement(address, true);
    },
    [loadLocationSettlement],
  );

  useEffect(() => {
    if (data) {
      setValue('registrationLocationRoute', data.route || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (registrationAddress?.value && (registrationAddress?.data as unknown as { type: 'manual' })?.type !== 'manual') {
      getLocationSettlement(String(registrationAddress.value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registrationAddress?.value]);
};
